export type Lang = 'de' | 'en';

export interface Strings {
  langName: string;
  switchTo: string;
  nav: { privacy: string; imprint: string; allTools: string };
  hero: { title: string; subtitle: string; localBadge: string };
  ui: {
    mode: string;
    modeFormat: string;
    modeMinify: string;
    input: string;
    output: string;
    copy: string;
    copied: string;
    download: string;
  };
  seo: {
    aboutTitle: string;
    aboutBody: string;
    faqTitle: string;
    faq: { q: string; a: string }[];
  };
  footer: { rights: string; noStorage: string };
}

const de: Strings = {
  langName: 'Deutsch',
  switchTo: 'English',
  nav: { privacy: 'Datenschutz', imprint: 'Impressum', allTools: 'Alle Tools' },
  hero: {
    title: 'JSON-Toolkit',
    subtitle:
      'JSON formatieren, validieren, minifizieren und nach YAML, TOML oder CSV umwandeln — alles lokal im Browser. Nichts wird gesendet.',
    localBadge: '100 % lokal · kostenlos',
  },
  ui: {
    mode: 'Aktion',
    modeFormat: 'Formatieren',
    modeMinify: 'Minifizieren',
    input: 'Eingabe',
    output: 'Ergebnis',
    copy: 'Kopieren',
    copied: 'Kopiert',
    download: 'Herunterladen',
  },
  seo: {
    aboutTitle: 'JSON sicher und lokal verarbeiten',
    aboutBody:
      'Dieses Toolkit formatiert, validiert und konvertiert JSON (YAML, TOML, CSV) ausschließlich lokal in deinem Browser. Deine Daten werden nicht an einen Server gesendet oder gespeichert.',
    faqTitle: 'Häufige Fragen',
    faq: [
      {
        q: 'Werden meine Daten gesendet?',
        a: 'Nein. Alle Umwandlungen laufen vollständig lokal im Browser.',
      },
      {
        q: 'Was passiert bei ungültigem JSON?',
        a: 'Du bekommst die genaue Fehlermeldung des Parsers angezeigt, statt eines stillen Fehlers.',
      },
      {
        q: 'Wie funktioniert JSON → CSV?',
        a: 'Gib ein JSON-Array von Objekten ein; die Schlüssel werden zu Spalten. CSV → JSON kehrt das um.',
      },
    ],
  },
  footer: {
    rights: 'Kostenlose Tools von ecosquirrel.',
    noStorage: 'Keine serverseitige Speicherung. Alles läuft lokal im Browser.',
  },
};

const en: Strings = {
  langName: 'English',
  switchTo: 'Deutsch',
  nav: { privacy: 'Privacy', imprint: 'Imprint', allTools: 'All tools' },
  hero: {
    title: 'JSON Toolkit',
    subtitle:
      'Format, validate and minify JSON and convert to YAML, TOML or CSV — all locally in your browser. Nothing is sent.',
    localBadge: '100% local · free',
  },
  ui: {
    mode: 'Action',
    modeFormat: 'Format',
    modeMinify: 'Minify',
    input: 'Input',
    output: 'Result',
    copy: 'Copy',
    copied: 'Copied',
    download: 'Download',
  },
  seo: {
    aboutTitle: 'Process JSON securely and locally',
    aboutBody:
      'This toolkit formats, validates and converts JSON (YAML, TOML, CSV) exclusively in your browser. Your data is not sent to a server or stored.',
    faqTitle: 'Frequently asked questions',
    faq: [
      {
        q: 'Is my data sent anywhere?',
        a: 'No. All conversions run entirely locally in the browser.',
      },
      {
        q: 'What happens with invalid JSON?',
        a: 'You get the exact parser error message instead of a silent failure.',
      },
      {
        q: 'How does JSON → CSV work?',
        a: 'Provide a JSON array of objects; keys become columns. CSV → JSON reverses it.',
      },
    ],
  },
  footer: {
    rights: 'Free tools by ecosquirrel.',
    noStorage: 'No server-side storage. Everything runs locally in your browser.',
  },
};

export const STRINGS: Record<Lang, Strings> = { de, en };
